/** One-line model explanation for why a suggestion was extracted. */
const MAX_EVIDENCE_DISPLAY_CHARS = 480;

export function extractionRationale(row) {
  const r = row?.rationale;
  if (r && String(r).trim()) return truncateForDisplay(String(r).trim());
  const q = row?.evidence_quote;
  if (q && String(q).trim()) return truncateForDisplay(String(q).trim());
  return "";
}

function truncateForDisplay(text) {
  const s = String(text || "");
  if (s.length <= MAX_EVIDENCE_DISPLAY_CHARS) return s;
  return `${s.slice(0, MAX_EVIDENCE_DISPLAY_CHARS - 1)}…`;
}
